
import { TaxInfo } from '@/store/dueDiligence/types';
import Vue from 'vue';
import { Component, InjectReactive, Prop, Watch } from 'vue-property-decorator';
import CPOpenAccountFormSubsection from '../open-account/form/CPOpenAccountFormSubsection.vue';
import CPOptionDropdownAdapter from '@/components/globals/adapters/CPOptionDropdownAdapter.vue';
import { AccountOpeningMetadataData } from '@/endpoints/types';
import { metadataNumberAdapter } from '@/utils/metadataAdapters';
import { CPTextInput } from '@capital-platforms/cpui';
import CPRadioGroup from '../open-account/input/CPRadioGroup.vue';
import { JointAccountType } from '@/types/jointAccountType';
import { AccountReasonNoTinOptions } from '@/utils/accountTypes';
import CPOptionDropdown from '../open-account/input/CPOptionDropdown.vue';

@Component({
    components: {
        CPOptionDropdownAdapter,
        CPOpenAccountFormSubsection,
        CPTextInput,
        CPRadioGroup,
        CPOptionDropdown
    }
})
export default class CPDueDiligenceAccountHolderTaxDetails extends Vue {
    @Prop({ required: true }) taxInfo!: TaxInfo;
    @InjectReactive() readonly viewOnly!: boolean;
    @InjectReactive() readonly jointAccountType!: JointAccountType;

    metadataNumberAdapter = metadataNumberAdapter;
    initialFiscalCountry: number | null = null;

    get rawCountries(): AccountOpeningMetadataData[] {
        return this.$store.getters['dueDiligence/rawCountries'];
    }

    handleFiscalResidenceInput(country: number) {
        this.$set(this.taxInfo, 'CountryOfFiscalResidence', country);
        this.$store.commit('dueDiligence/setFiscalResidenceChanged', {
            type: this.jointAccountType,
            previousCountry: this.initialFiscalCountry,
            newCountry: country
        });
    }

    public reasonOptions = AccountReasonNoTinOptions;

    get hasTin(): boolean {
        return !!this.taxInfo.TinNo;
    }

    @Watch('taxInfo.TinNo')
    onTinChanged(val: string) {
        if (val) {
            this.taxInfo.ReasonNoTinNumber = null;
        }
    }


    mounted() {
        this.initialFiscalCountry = this.taxInfo.CountryOfFiscalResidence;
    }
}
